// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyUnarchiveWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyUnarchiveRequestWebDto } from '../..';

export const RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Path = '/api/web/v1/users/properties/unarchive';

/**
 * Unarchive a listing and its dupes
 */
export const RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive = (
  postData: UserPropertyUnarchiveRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyUnarchiveRequestWebDto, void>(
    {
      endpoint: RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
